export enum ErrorsMessages {
  NETWORK_ERROR = 'NETWORK_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  REQUEST_CANCEL = 'REQUEST_CANCEL',
  UNAUTHORIZED_DEVICE = 'unauthorized_device',
  MALFORMED_UTF8_DATA = 'Malformed UTF-8 data',
  BIOMETRY_CLOSE = 'user_cancel',
  UNAVAILABLE_ACCOUNT = 'UNAVAILABLE_ACCOUNT',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  TRANSACTION_IN_PROCESS = 'TRANSACTION_IN_PROCESS',
  TRANSACTION_ALREADY_APPROVED = 'TRANSACTION_ALREADY_APPROVED',
  INVALID_BILLET_AMOUNT = 'INVALID_BILLET_AMOUNT',
  PAYMENT_OUTSIDE_OF_HOURS_ALLOWED = 'PAYMENT_OUTSIDE_OF_HOURS_ALLOWED',
  ADDRESS_NOT_FOUND = 'ADDRESS_NOT_FOUND',
  ADDRESS_NOT_FOUND_RETRY_MANUAL = 'ADDRESS_NOT_FOUND_RETRY_MANUAL',
  DEVICE_ID_NOT_SET = 'DEVICE_ID_NOT_SET',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  INVALID_CREDENTIALS_KEYCLOAK = 'invalid_client',
  EXPIRED_SESSION = 'EXPIRED_SESSION',
  MISSING_KEYS = 'MISSING_KEYS',
  REJECTED_ACCOUNT = 'REJECTED_ACCOUNT',
  MISSING_PAYMENT_LINK = 'MISSING_PAYMENT_LINK',
  MISSING_PAYLOAD_ID = 'MISSING_PAYLOAD_ID',
  UNAVAILABLE_RETURN_FILE = 'UNAVAILABLE_RETURN_FILE',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  BLOCKED_ACCOUNT = 'BLOCKED_ACCOUNT',
  PIX_INVALID_PARAMS = 'invalid_params',
  USER_ALREADY_CREATED = 'USER_ALREADY_CREATED',
  PAY_STUB_NOT_FOUND = 'PAY_STUB_NOT_FOUND',
  INVALID_GRANT = 'invalid_grant',
  EMPLOYEE_ENTITY_NOT_FOUND = 'EMPLOYEE_ENTITY_NOT_FOUND',
  CARD_CREATION_IN_PROCESS = 'card_creation_in_process',
  NEXT_TO_LAST_ATTEMPT = 'NEXT_TO_LAST_ATTEMPT',
  LAST_ATTEMPT = 'LAST_ATTEMPT',
  RESTRICTED_LIST = 'restricted-list',
  NOT_ALLOWED = 'not-allowed',
  MAX_DEVICES_PER_USER = 'max_devices_per_user',
  DISABLED_USER = 'DISABLED_USER',
  PIX_KEY_NOT_FOUND = 'pix_key_not_found',
  PORTABILITY_ERROR = 'portability_error',
  PORTABILITY_ERROR_CONFIRM = 'portability_error_confirm',
  INVALID_TOKEN = 'invalid_token',
  CLAIM_ALREADY_EXISTS_FOR_KEY = 'ClaimAlreadyExistsForKey',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  TRANSACTION_NOT_APPROVED = 'transaction_not_approved',
  TRANSACTION_LAST_ATTEMPT_BEFORE_BLOCK = 'transaction_last_attempt_before_block',
  TRANSACTION_FINAL_ATTEMPT = 'transaction_final_attempt',
  BLOCKED_ACCOUNT_ERROR = 'blocked_account',
  INVALID_CODE_AREA = 'invalid_code_area',
  PIX_KEY_FRAUD = 'pix_key_fraud',
  USER_OR_ACCOUNT_FRAUD_RESTRICTION = 'UserOrAccountWithFraudRelatedRestriction',
  LIMIT_NUMBER_OF_KEYS = 'limit_number_of_keys',
  INVALID_PIX_KEY = 'invalid_pix_key',
  YOU_CANNOT_PERFORM_THIS = 'you_cannot_perform_this',
  CARD_NOT_FOUND = 'card_not_found',
  BLOCKED_DEVICE = 'blocked_device',
  FORBIDDEN_ACCESS = 'FORBIDDEN_ACCESS',
  MISSING_INTEGRITY_TOKEN = 'missing_integrity_token',
  INVALID_INTEGRITY_TOKEN = 'invalid_integrity_token',
  INTEGRITY_TOKEN_EXPIRED = 'integrity_token_expired',
  INTEGRITY_VALIDATION_FAILED = 'integrity_validation_failed',
  MISSING_RECAPTCHA_TOKEN = 'missing_recaptcha_token',
  INVALID_RECAPTCHA_TOKEN = 'invalid_recaptcha_token',
  TIMEOUT_OF_10000MS_EXCEEDED = 'TIMEOUT_OF_10000MS_EXCEEDED',
  NO_FUNDS_AVAILABLE = 'no_funds_available',
  BLOCKED_USER = 'blocked_user',
  TRANSACTION_NOT_FOUND_KEY = 'transaction_not_found',
  INVALID_TAX_IDENTIFIER = 'invalid_tax_identifier',
}

export enum PinErrors {
  INVALID_SIZE = 'INVALID_SIZE',
  MUST_NOT_CONTAIN_LETTERS = 'MUST_NOT_CONTAIN_LETTERS',
  SAME_DIGIT_MORE_THAN_TWICE = 'SAME_DIGIT_MORE_THAN_TWICE',
  DIGIT_SEQUENCE = 'DIGIT_SEQUENCE',
  USER_BIRTHDAY = 'USER_BIRTHDAY',
}

export enum BilletErrors {
  TRANSACTION_ALREADY_COMPLETED = 68,
  PAYMENT_NOT_COMPLETED_CHANNEL = 258,
  MAXIMUM_DELAY_DAYS_EXCEEDED = 260,
  PAYMENT_ALREADY_MADE = 183,
  NON_RECEIVABLE_DOCUMENT = 245,
  PAYMENT_NOT_AUTHORIZED_EXPIRED_DOCUMENT = 244,
  INVALID_BARCODE = 243,
  INVALID_BARCODE_ALT = 240,
  PAYMENT_NOT_ALLOWED = 184,
  TRANSACTION_NOT_FOUND = 24,
  RECORD_QUERY_ISSUE = 612,
  PAYEE_NOT_AUTHORIZED = 619,
  PARTNER_COMMUNICATION_FAILURE = 658,
  INSTITUTION_COMMUNICATION_FAILURE = 620,
  PENDING_CONFIRMATION = 621,
  REGISTRATION_DISCREPANCY = 648,
  BOLETO_ALREADY_CLEARED = 628,
  INELIGIBLE_BENEFICIARY = 630,
  BENEFICIARY_NOT_REGISTERED = 631,
  BENEFICIARY_UNDER_REVIEW = 632,
  PARTIAL_PAYMENT_LIMIT_EXCEEDED = 633,
  OPERATIONAL_CANCELLATION_DUPLICATE = 634,
  OPERATIONAL_CANCELLATION_REGISTERED = 635,
  EXCEEDED_PARTIAL_VALUE = 636,
  INELIGIBLE_BENEFICIARY_DIFFERENT_BANK = 637,
  BENEFICIARY_UNDER_REVIEW_DIFFERENT_BANK = 638,
  BOLETO_BEYOND_PAYMENT_DEADLINE = 639,
  BARCODE_NOT_FOUND = 642,
  SPTRANS_UNAVAILABLE = 714,
  PAYEE_NOT_AUTHORIZED_PAYMENT_NOT_COMPLETED = 481,
  OUT_OF_CALL_VOLUME_QUOTA = 403,
  UPDATED_AMOUNT_UNAVAILABLE = 780,
  TAX_OUTSIDE_SCHEDULED_HOURS = 820,
  BARCODE_CONVERSION_ERROR = 821,
  DIGITABLE_LINE_CONVERSION_ERROR = 822,
  INVALID_BARCODE_420 = 420,
  INVALID_SCHEDULED_DATE = 421,
  GENERIC_ERROR = 999,
}

export default ErrorsMessages;
